import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import MainCTA from '../components/MainCTA';
import Pricing from '../components/Pricing';
import Services from '../components/Services';
import About from '../components/About';
import Comparison from '../components/Comparison';
import Achievement from '../components/Achievement';
import Steps from '../components/Steps';
import Eligibility from '../components/Eligibility';
import FAQ from '../components/FAQ';
import Testimonials from '../components/Testimonials';
import HowTo from '../components/HowTo';
import Benefits from '../components/Benefits';
import InfoSections from '../components/InfoSections';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Trademark Registration Services USA - Fast & Affordable | Global Trademark USA</title>
        <meta name="description" content="Register your trademark for only $45 with Global Trademark USA. Expert USPTO trademark filing, copyright registration, and brand protection services across the USA." />
        <meta name="keywords" content="trademark registration, USPTO filing, trademark attorney, brand protection, trademark search, affordable trademark registration" />
        <link rel="canonical" href="https://yourdomain.com/" />
      </Helmet>
      <Hero />
      <MainCTA />
      <Pricing />
      <Services />
      <About />
      <Comparison />
      <Achievement />
      <Steps />
      <Eligibility />
      <FAQ />
      <Testimonials />
      <HowTo />
      <Benefits />
      <InfoSections />
    </>
  );
};

export default Home;